module.exports = __webpack_public_path__ + "img/teammanagement_1.e6b2e6ec.jpg";